import { createApp } from 'vue';
import WebmToWavConverter from '@/Components/WebmToWavConverter.vue';
import '@styles/app.css';

createApp(WebmToWavConverter).mount('#webm-to-wav-converter');
